import { render } from "./ApplicantSelection.vue?vue&type=template&id=5a19115e"
import script from "./ApplicantSelection.vue?vue&type=script&lang=js"
export * from "./ApplicantSelection.vue?vue&type=script&lang=js"

import "./ApplicantSelection.vue?vue&type=style&index=0&id=5a19115e&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__